import React from 'react';
import './hero.css';
import hero_img from '../../assets/hero-image.png' 
import { useHistory } from 'react-router';

function Hero() {
    const history = useHistory();
    const handleClick = () => {
        history.push('/enrollment')
    }
    return (
        <div className="hero__container">
        <div className="hero__main">

            <div data-aos="fade-left" className="hero__left">
                <div className="head__one">
                Studying Online is now much easier
                </div>
                <div data-aos-duration="2500" data-aos="fade-left"  className="paragraph">
                Charis Coding Club teaches you coding in a fun and interactive manner.
                </div>
                <button data-aos-duration="500"  data-aos="fade-right" className="primary__button" onClick={handleClick}>
                    Enroll Now
                </button>
            </div>
            <div className="hero__right"  data-aos="fade-down">
                {/* <img src={hero_img} alt="" /> */}
            </div>        
        </div>


        </div>
    )
}

export default Hero
